(()=>{
  if(window.__senfinecoFitmentGridLoaded)return;
  window.__senfinecoFitmentGridLoaded=true;
  const YMM_RESULTS = /\/collections\/all\/[^/?#]*es[ri]\d+/i.test(location.pathname) || /(?:^|[?&])(ymm|vehicle|fitment|make|model|year)=/i.test(location.search);
  document.documentElement.classList.toggle('sf-ymm-results-page', YMM_RESULTS);

  const GRID='senfineco-fitment-grid-live';
  const FIELD='senfineco-fitment-field-live';
  const CONTENTS='senfineco-fitment-contents-live';
  let timer;

  const visible = el => !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));

  function commonAncestor(nodes){
    if(!nodes.length) return null;
    let a=nodes[0];
    while(a && !nodes.every(n=>a.contains(n))) a=a.parentElement;
    return a;
  }

  function highestSingleControlWrapper(control, root, controls){
    let node=control;
    while(node.parentElement && node.parentElement!==root){
      const p=node.parentElement;
      const count=controls.filter(c=>p.contains(c)).length;
      if(count!==1) break;
      node=p;
    }
    return node;
  }

  function clearOld(root){
    root.querySelectorAll('.'+FIELD).forEach(el=>el.classList.remove(FIELD));
    root.querySelectorAll('.'+CONTENTS).forEach(el=>{
      el.classList.remove(CONTENTS);
      el.style.removeProperty('display');
    });
  }

  function applyGrid(section){
    const allSelects=[...section.querySelectorAll('select')].filter(visible);
    if(allSelects.length<4) return false;

    const controls=allSelects.slice(0,4);
    let root=commonAncestor(controls);
    if(!root || root===section) {
      const form=controls[0].closest('form');
      if(form && controls.every(c=>form.contains(c))) root=form;
    }
    if(!root) return false;

    clearOld(root);
    root.classList.add(GRID);
    root.style.setProperty('display','grid','important');
    root.style.setProperty('grid-template-columns','repeat(2,minmax(0,1fr))','important');
    root.style.setProperty('column-gap','12px','important');
    root.style.setProperty('row-gap','14px','important');
    root.style.setProperty('align-items','end','important');
    root.style.setProperty('width','100%','important');

    controls.forEach(control=>{
      const wrap=highestSingleControlWrapper(control,root,controls);
      wrap.classList.add(FIELD);
      wrap.style.setProperty('width','100%','important');
      wrap.style.setProperty('min-width','0','important');
      wrap.style.setProperty('margin','0','important');
      control.style.setProperty('width','100%','important');
      control.style.setProperty('min-width','0','important');
      control.style.setProperty('max-width','100%','important');
      control.style.setProperty('box-sizing','border-box','important');

      let p=wrap.parentElement;
      while(p && p!==root){
        p.classList.add(CONTENTS);
        p.style.setProperty('display','contents','important');
        p=p.parentElement;
      }
    });

    const buttons=[...root.querySelectorAll("button,input[type='submit'],[role='button']")].filter(visible);
    const searchBtn=buttons.find(b=>/بحث|search/i.test((b.textContent||b.value||b.getAttribute('aria-label')||'').trim())) || buttons.find(b=>b.matches("button[type='submit'],input[type='submit']"));
    if(searchBtn){
      let wrap=searchBtn;
      while(wrap.parentElement && wrap.parentElement!==root && !controls.some(c=>wrap.parentElement.contains(c))) wrap=wrap.parentElement;
      let p=wrap.parentElement;
      while(p && p!==root){
        p.style.setProperty('display','contents','important');
        p=p.parentElement;
      }
      wrap.style.setProperty('grid-column','1 / -1','important');
      wrap.style.setProperty('width','100%','important');
      searchBtn.style.setProperty('width','100%','important');
    }
    return true;
  }

  function scan(){
    if(!matchMedia('(max-width:749px)').matches) return;
    const sections=[...document.querySelectorAll("main [id^='shopify-section-'], main .shopify-section")];
    let done=false;
    for(const section of sections){
      if(section.querySelectorAll('select').length>=4 && applyGrid(section)){ done=true; break; }
    }
    if(!done){
      const selects=[...document.querySelectorAll('main select')].filter(visible);
      if(selects.length>=4){
        const section=selects[0].closest("[id^='shopify-section-'],.shopify-section") || document.querySelector('main');
        if(section) applyGrid(section);
      }
    }
  }

  function queue(){ clearTimeout(timer); timer=setTimeout(scan,120); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',queue,{once:true}); else queue();
  const observer=new MutationObserver(queue);
  observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',queue);
  window.addEventListener('resize',queue);
  setTimeout(scan,500); setTimeout(scan,1500); setTimeout(scan,3000); setTimeout(scan,6000);
})();
